export const PREVIEW_STORE_PATH = 'lines/preview/'
